module.exports = __webpack_public_path__ + "img/b7.3414474b.png";